import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute, UnauthorizedPage } from "@/components/ProtectedRoute";
import Login from "./pages/Login";
import Contracts from "./pages/Contracts";
import ContractDetail from "./pages/ContractDetail";
import NewContract from "./pages/NewContract";
import BusinessUnits from "./pages/BusinessUnits";
import Users from "./pages/Users";
import Roles from "./pages/Roles";
import DebugClaims from "./pages/DebugClaims";
import NotFound from "./pages/NotFound";

const App = () => (
  <TooltipProvider>
    <Toaster />
    <Sonner />
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        
        {/* Public/User accessible routes */}
        <Route path="/" element={<ProtectedRoute><Contracts /></ProtectedRoute>} />
        <Route path="/contracts" element={<ProtectedRoute><Contracts /></ProtectedRoute>} />
        <Route path="/contracts/:id" element={<ProtectedRoute><ContractDetail /></ProtectedRoute>} />
        
        {/* Manager and above can create/edit contracts */}
        <Route path="/contracts/new" element={
          <ProtectedRoute requireAnyRole={['Admin', 'Manager']}>
            <NewContract />
          </ProtectedRoute>
        } />
        
        {/* Admin only routes */}
        <Route path="/business-units" element={
          <ProtectedRoute requiredRole="Admin">
            <BusinessUnits />
          </ProtectedRoute>
        } />
        <Route path="/users" element={
          <ProtectedRoute requiredRole="Admin">
            <Users />
          </ProtectedRoute>
        } />
        <Route path="/roles" element={
          <ProtectedRoute requiredRole="Admin">
            <Roles />
          </ProtectedRoute>
        } />
        
        {/* Debug route - authenticated users only */}
        <Route path="/debug/claims" element={
          <ProtectedRoute>
            <DebugClaims />
          </ProtectedRoute>
        } />
        
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </TooltipProvider>
);

export default App;
